import dayjs from "dayjs";
import { CustomEnchorNotification } from "../../../components/CustomEnchorNotification/CustomEnchorNotification";
import { TranslateFn } from "../../../utils/types";

/**
 * Colonnes de la liste des notifications.
 *
 * Prend `t` en argument plutot que d'etre une constante de module : une
 * constante est evaluee une seule fois, a l'import, et resterait figee dans la
 * langue active au demarrage. Meme convention que getColumnsListVehicle.
 */
export const getColumnsNotification = (t: TranslateFn) => [
  {
    header: t("common.date", "Date"),
    field: "",
    render: (rowData: Record<string, any>) => {
      return <div>{rowData?.date && dayjs(rowData.date).format("DD-MM-YYYY")}</div>;
    },
  },
  { header: t("event.interventionType", "Service type"), field: "type" },
  { header: t("vehicule.vehicle", "Vehicle"), field: "brandModel" },
  { header: t("vehicule.brand", "Brand"), field: "brand" },
  { header: t("collaborator.name", "Last name"), field: "lastname" },
  { header: t("collaborator.firstName", "First name"), field: "firstname" },
  {
    header: "",
    field: "",
    render: (row: Record<string, any>) => {
      return (
        <CustomEnchorNotification
          notification={row as TNotification}
          isRead={Number(row.is_read) === 0 ? false : true}
        />
      );
    },
  },
];
